import type { TimelyPresentableAiPrediction } from '@timelyapp/integration-cloud-api-spec';
import { type ConsolidationParams, consolidatePredictions } from './consolidate-predictions';

/**
 * Merges fractured or ~identical AI predictions based on the specified `matchOn` parameter
 *
 * @see {@link consolidatePredictions} for details on the `matchOn` parameter.
 */
export const consolidatePredictionsAsDateMap = (
  ai_predictions: TimelyPresentableAiPrediction[],
  params: ConsolidationParams = { matchOn: 'compatibility' }
) => {
  const consolidatedPredictions = consolidatePredictions(ai_predictions, params);
  const groupedIntervalsArray = consolidatedPredictions.reduce(
    (acc, prediction) => {
      const date = prediction.date;
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(prediction);
      return acc;
    },
    {} as Record<string, TimelyPresentableAiPrediction[]>
  );

  return groupedIntervalsArray;
};
